import React from 'react'
import SetUpAccountPage from '../../components/Merchant/MerchantOnboarding/SetUpAccount';

const SetUpAccount = () => {
  return (
    <SetUpAccountPage />
  )
}

export default SetUpAccount;